import React from "react"
import Stack from '@mui/material/Stack'
import Button from "@mui/material/Button"
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule'

export default function HighlightedButton(props) {
    const {handleClick, value, highlight} = props

    return (<>
        <Button 
            onClick={handleClick} 
            value={value}
        >
            <Stack 
                direction="column"
                alignItems="center"
                justifyContent="flex-end"
            >
                {/* {value} */}
        <Typography 
            variant="h7"
            sx={{ 
                position: "relative", 
                top: 10
            }}
        >
            {value}
        </Typography>

        {/* <Box sx={{ display: 'flex', width: 100 }}> */}
        <HorizontalRuleIcon 
        // height='64' 
        // width='48'
            color={highlight ? "selectedPage" : "notSelected"}
            sx={{ 
                position: "relative", 
                top: -6
            }}
            // viewBox="0 0 100 100"
            // fontSize="inherit"
            // style={{ width: '18vw'}}
        />
        {/* </Box> */}
            </Stack>
        </Button>
    </>)
}